export enum IdsStepsTreatmentWizardModel {
    FAMILIES,
    PAYMETHODS = 10,
    PAYMENT,
    RESULT,
}
